import React from 'react'
import { Helmet } from 'react-helmet-async'

export default function Husvet2026() {
  // The site header is sticky (60px) and footer is fixed.
  // We reserve room so the iframe content doesn't hide behind the footer.
  return (
    <>
      <Helmet>
        <title>Húsvéti Labirintus | BeArt Művészetterápia</title>
        <meta name="description" content="Játssz a Húsvéti Labirintus játékot a BeArt oldalon!" />
        <link rel="canonical" href="https://beart.hu/husvet2026" />
      </Helmet>

      <div className="h-[calc(100dvh-60px-64px)] w-full overflow-hidden">
        <iframe
          title="Húsvéti Labirintus"
          src="/husvet2026-game/index.html"
          className="h-full w-full border-0"
        />
      </div>
    </>
  )
}

